export default "__VITE_ASSET__BA18Q8wY__"